module.exports = __webpack_public_path__ + "img/组 5.c1a976d3.png";